export enum ChartType {
  DEBIT = 'DEBIT',
  CREDIT = 'CREDIT',
}

export interface FormValues {
  id?: string;
  name: string;
  type: ChartType;
  active?: boolean;
}

export interface Category {
  active: boolean;
  id: string;
  isClientAccount: boolean;
  name: string;
  type?: ChartType;
  accountGroups?: Group[];
  number: string;
}

export interface Group {
  id: string;
  description: string;
  number: string;
  active?: boolean;
  categoryId?: string;
  category?: Category;
  isClientAccount?: boolean;
  primaryAccounts?: PrimaryAccount[];
}

export interface PrimaryAccount {
  description: string;
  number: string;
  active: boolean;
  groupId: string;
  group: Group;
  id: string;
}
